import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Spinner,
  Button,
  FormControl,
  FormGroup
} from 'modules/theme';
import { AuthBox, AuthTextBox, Links } from '../styles';
import { Alert } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { apiUrl } from 'helpers/dotenv';
import { localStore } from 'helpers';
import { ControlLabel } from 'react-bootstrap';
import { globalAction } from 'store/action';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { NotFound } from '../../theme';
import { HiOutlineUserCircle } from 'react-icons/hi';
import { MdLock, MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';

const propTypes = {
  history: PropTypes.object
};

class TenantSignIn extends Component {
  constructor(props) {
    super(props);

    this.mAPI = new APIManager();
    this.tURL = apiUrl;
    this.loginUrl = '';

    let isLogin = true;
    let tUserID = localStorage.getItem('USER_ID');
    let selectedTenant = localStorage.getItem('selected-tenant');
    if (
      tUserID === null ||
      typeof tUserID === 'undefined' ||
      tUserID === 'undefined' ||
      tUserID === ''
    ) {
      isLogin = false;
    }

    this.state = {
      companyLoading: false,
      companyVerified: false,
      company: {},
      companyName: selectedTenant,
      userID: '',
      email: '',
      password: '',
      userName:"",
      loginForm: isLogin,
      isLoading: false,
      show: false,
      showPassword: false,
      username: "",
    }

    this.login = this.login.bind(this);
    this.tokenUser = this.tokenUser.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUserIDChange = this.handleUserIDChange.bind(this);
    // this.validateCompany = this.validateCompany.bind(this);
    this.handleVisibilityClick = this.handleVisibilityClick.bind(this);

  }

  resetAllData() {
    this.setState({
      email: '',
      password: '',
      userName: ""
    })
  }

  apiResponse(errorCode, data) {
    
    if (errorCode === 401) {
      Alert.success(`Authentication Failed!!`);
      this.resetAllData();
      this.props.closeModal(true);
      
    } else {
      // Alert.error(`${data.message}`);
      // Alert.error('error')
      localStore.removeItem("token");
      localStore.removeItem("user");
      
      let message = data && data.message ? data.message : "Something went Wrong";
      Alert.error(message);
      // window.location.href = "http://35.154.201.165/sign-in";
    }
  }

  setForceParam(userId, url, isSecure = true) {
    let http = 'http://';
    let ws = 'ws://';
    if (isSecure) {
      http = 'https://';
      ws = 'wss://';
    }
    localStorage.setItem('USER_ID', userId);
    localStorage.setItem(
      'REACT_APP_API_SUBSCRIPTION_URL',
      `${ws}${url}/${userId}/api/`
    );
    localStorage.setItem('REACT_APP_API_URL', `${http}${url}/${userId}/api/`);
    localStorage.setItem(
      'CLOUD_APP_API_URL',
      'https://app.streamspace.ai/cloudManager'
    );
    localStorage.setItem(
      'REACT_FS_SERVER_HOST',
      `${http}${url}/${userId}/fs/api/play/`
    );
    localStorage.setItem('IS_CLOUD', false);
  }

  tokenUser(rcs, userDetails) {
    
    try{
      localStore.setItem("token", rcs);
      localStore.setItem("user", JSON.stringify(userDetails));
      localStore.setItem("reffer-origin", document.referrer);
  
    } catch(e) {
      console.log(e);
      return <NotFound />
    }
    window.location.href = "/rcs/";
    // this.mAPI.sendPostAPI(
    //   `${smsServer}sms/api/v1/profile`,
    //   {},
    //   data => {
    //       let user = {name: data["client-profile"].name, role: data["client-profile"].role, peid: data["client-profile"].principleEntityId};
    //       localStore.setItem('user', JSON.stringify(user));

    //       window.location.href = "/whatsapp/";
        
    //     // else {
    //     //   window.location.href = "/sign-in/";


    //     // }
    //   },
    //   (err, data) => {
    //     console.log(err,data);
    //     this.apiResponse(err,data);
    //     // Alert.error("User not found!");
    //     // return null;
    //   },
    //   "direct",
    // );

    return null;
  }


  async login(e) {
    e.preventDefault();
    const { username, password } = this.state;
    // const cookies = new Cookies();
    // const ipAddress = await axios.get('https://geolocation-db.com/json/').then(res => res.data.IPv4);
    // const date = new Date();
// 2021-02-05 15:20:10
    this.mAPI.sendPostAPI(
      `${process.env.REACT_APP_AUTH_API}create/`,
      {
        username: username,
        password: password,
      },
      data => {

        if (data) {
          let token = data.access;
          let user = { name: "7oceanpk", role: "2", peid: "", email: "", user_name: ""};
        try {
          localStore.setItem('token', token);
        } catch (e) {
          console.log(e);
        }
        try {
          localStore.setItem('user', JSON.stringify(user));
        } catch (e) {
          console.log(e);
        }
        // this.props.history.push("/");
        Alert.success("Succesfully Logged In!!");
        window.location.href = '/';
      }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (error === 401) {
          Alert.error("Please enter valid username or password!");
        } else {
          this.apiResponse(error, data);
        }
        // else if (error === 500 || error === 501 || error === 502) {
        //   Alert.error("Something went wrong!");
        // } 
        // if( error === 401) {
        //   Alert.error(`Something went wrong! Please check credentials.`);
        //   window.location.href = "/sign-in";
        // }
        
        // this.setState({
        //   TenantsignInLoading: false
        // });
        // if (data && data.message) {
        //   Alert.error(data.message || "Succesfully logged in!!");
        // } else {
        
        // }
      },
      'direct'
    );
  }
  // validateCompany(e) {
  //   e.preventDefault();
  //   this.setState({ companyLoading: true });
  //   var _this = this;
  //   const { companyName } = this.state;
  //   const { dynamicUpdate } = this.props;
  //   this.mAPI.sendGetAPI(
  //     `company/${companyName}`,
  //     origanisation => {
  //       try {
  //         if (
  //           origanisation &&
  //           origanisation.accessUrl &&
  //           origanisation.socketUrl
  //         ) {
  //           dynamicUpdate({ key: 'accessUrl', value: origanisation.accessUrl });
  //           dynamicUpdate({ key: 'socketUrl', value: origanisation.socketUrl });
  //           dynamicUpdate({
  //             key: 'sipUrl',
  //             value: origanisation.cpassUrl || 'wss://cpaas-j.streamspace.ai'
  //           });
  //           _this.mAPI.updateUrl(origanisation.accessUrl, companyName);
  //           localStore.setItem('selected-tenant', companyName);
  //           _this.loginUrl = `${origanisation.accessUrl}/v1`;
  //           console.log(`[getOrganisation] done`, origanisation);
  //         } else {
  //           _this.mAPI.clearStorage();
  //           console.log(`[getOrganisation] company not found`);
  //         }
  //       } catch (error) {
  //         console.log(`[getOrganisation] error`, error);
  //         _this.mAPI.clearStorage();
  //       }
  //       _this.setState({
  //         companyVerified: true,
  //         company: origanisation.detail,
  //         companyLoading: false
  //       });
  //     },
  //     (error, data) => {
  //       console.log(`Error:`, error);
  //       this.setState({
  //         companyLoading: false
  //       });
  //       if (data && data.message) {
  //         Alert.error(`${data.message}`);
  //       } else {
  //         Alert.error(`Company not found!!!`);
  //       }
  //     },
  //     'public'
  //   );
  // }

  handleEmailChange(e) {
    e.preventDefault();
    let username = "";
    if(e.target.value) {
      username=e.target.value.trim();
    }
    this.setState({ email: username, username: username });

  }

  handleUserNameChange(e) {
    e.preventDefault();
    this.setState({ username: e.target.value });
  }

  handleUserIDChange(e) {
    e.preventDefault();
    this.setState({ userID: e.target.value });
  }

  
  handleVisibilityClick() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }

  handlePasswordChange(e) {
    e.preventDefault();
    let password="";
    if(e.target.value) {
      password=e.target.value.trim();
    }
    this.setState({ password: password });

  }

  renderLoginForm() {
    const { __ } = this.context;
    return (
      <div>
      <h2
        style={{
          marginBottom: "20px",
          fontSize: "30px",
          paddingTop: "5px",
          color: "black",
          fontWeight: "600",
        }}
      >
        {__("Login")}
      </h2>
        <form onSubmit={this.login}>
        <FormGroup>
              <FormControl
                type="text"
                placeholder={__("Username")}
                value={this.state.username}
                style={{ padding: "20px 20px 20px 60px"}}
                required
                maxLength={70}
                onChange={this.handleEmailChange}
               
              />
              <HiOutlineUserCircle
                className="input-icon"
                style={{
                  position: "absolute",
                  top: "12px",
                  left: "28px",
                  color: "blue",
                  width: "2em",
                  height: "2em",
                }}
              />
            </FormGroup>

            <FormGroup>
              <FormControl
                type={this.state.showPassword ? "text" : "password"}
                placeholder={__("Password")}
                value={this.state.password}
                required
                onChange={this.handlePasswordChange}
              />

              <span
                style={{
                  // transform: "translateY(-40px)",
                  // alignContent: "flex-end",
                  fontSize: "30px",
                  cursor: "pointer",
                  position:"absolute",
                  top: "8px",
                  right: "30px",
                  color:"lightgray"
                  
                }}
                // className="material-symbols-outlined"
                onClick={this.handleVisibilityClick}
              >
                {this.state.showPassword ? <MdOutlineVisibility /> : <MdOutlineVisibilityOff />}

                {/* {this.state.showPassword ? "visibility" : "visibility_off"} */}
              </span>

              <MdLock
                className="input-icon"
                style={{
                  position: "absolute",
                  top: "13px",
                  left: "28px",
                  color: "blue",
                  width: "2em",
                  height: "2em",
                }}
              />
            </FormGroup>
          {/* <Links style={{ marginTop: '-12px', textAlign: 'start', float: 'left' }}>
            <FormControl
              componentClass="checkbox"
            />
            <span style={{ marginLeft: '5px' }}>{__('Remember me')}</span>
          </Links>
          <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
            <Link to="/forgot-password">{__('Forgot Password?')}</Link>
          </Links> */}
          {/* <div>
            <Button
              btnStyle="default"
              type="submit"
              block
              style={{ marginTop: '30px' }}
            >
              Login
            </Button>
            <Links style={{ marginTop: '15px', textAlign: 'center' }}>
              Don't have an account ?{' '}
              <Link to="/signup">{__('Register Now')}</Link>
            </Links>
          </div> */}
          <div>
            {/* <Button
              btnStyle="default"
              type="submit"
              // block
              style={{ marginTop: '30px', border: '1px solid #C7C7C7' }}
            >
              Sign In
            </Button> */}
            <Button
                btnStyle="default"
                type="submit"
                block
                style={{
                  marginTop: "30px",
                  padding: "13px",
                  borderRadius: "35px",
                  fontSize: "18px",
                  fontFamily: "700",
                  textTransform: "capitalize",
                }}
                size="small"
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? (
                  <Spinner
                    style={{
                      height: "3px",
                      marginTop: "-15px",
                      padding: "10px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                      fontSize: "50px",
                    }}
                  />
                ) : (
                  "Login"
                )}
              </Button>

            {/* <Links style={{ marginTop: '10px' }}>
              <Link to="/sign-in">{__('Change Tenant')}</Link>
            </Links> */}

            {/* <Button
                btnStyle="link"
                type="simple"
                style={{ marginTop: '7px', width: '100%', textAlign: 'left', boxShadow: 'none }}
                onClick={() => {
                  this.setState({ companyVerified: false });
                }}
              >
                Login with another ID
              </Button> */}
            {/* <a
                onClick={() => {
                  this.setState({ companyVerified: false });
                }}
              >
                back
              </a> */}
            {/* <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
              <Link to="/otp">{__('Comfirm Email')}</Link>
            </Links> */}
          </div>
        </form>
      </div>
    );
  }

  renderCompanyValidation() {
    const { __ } = this.context;
    return (
      <div>
        <h2 style={{ marginBottom: '10px' }}>{__('Tenant')}</h2>
        <p>{__('Login with your corporate credentials.')}</p>
        <form onSubmit={this.validateCompany}>
          <FormGroup>
            <ControlLabel>Username</ControlLabel>
            <FormControl
              type="text"
              placeholder={__('Enter username')}
              value={this.state.companyName}
              required
              onChange={this.handleUserNameChange}
            />
          </FormGroup>
          <div>
            {/* <Button
              btnStyle="default"
              type="submit"
              // block
              style={{ marginTop: '30px', border: '1px solid #C7C7C7' }}
            >
              Sign In
            </Button> */}
            <Button
              btnStyle="default"
              type="submit"
              block
              style={{ marginTop: '30px', padding: '13px' }}
              size="small"
            >
              {this.state.companyLoading ? (
                <Spinner style={{ height: '3px', marginTop: '-15px', padding: '10px', marginBottom: '10px' }} />
              ) : (
                'Submit'
              )}
            </Button>
          </div>
        </form>
      </div>
    );
  }
  renderForm() {
    // if (this.state.companyVerified) {
      return this.renderLoginForm();
    // } else {
    //   return this.renderCompanyValidation();
    // }
  }

  render() {
    const { __ } = this.context;
    const cookies = new Cookies();
    const rcsToken = cookies.get("rcs-token");
    const userDetails = cookies.get("userDetails");
    const isPortal = process.env.REACT_APP_IS_PORTAL === "true";
   
    if(!isPortal) {
      return <div>  
        <AuthBox>{this.renderForm()}</AuthBox>
      </div>
    } else {
      if(rcsToken) {
        this.tokenUser(rcsToken, userDetails);
      }else {
        window.location.href = `${process.env.REACT_APP_HOSTNAME}/sign-in`;
        return null;
      
      }
    }
  }
}

TenantSignIn.propTypes = propTypes;
TenantSignIn.contextTypes = {
  __: PropTypes.func
};
const stateToProps = state => ({
  // loginToken: globalStateSelector.getDynamic(state, { key: 'loginToken' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default withRouter(connect(stateToProps, dispatchToProps)(TenantSignIn));

// export default withRouter(TenantSignIn);



// WEBPACK FOOTER //
// ./src/modules/auth/components/Tenant-Signin.js